import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface WebsiteInfoState {
  mainSocialLinks: {
    website: string;
    instagram: string;
    linkedin: string;
    facebook: string;
  };
  additionalPlatforms: Array<{
    id: string;
    platform: string;
    link: string;
    title?: string;
    otherLink?: string;
    logo?: string;
  }>;
}

const initialState: WebsiteInfoState = {
  mainSocialLinks: {
    website: '',
    instagram: '',
    linkedin: '',
    facebook: '',
  },
  additionalPlatforms: [],
};

const websiteInfoSlice = createSlice({
  name: 'websiteInfo',
  initialState,
  reducers: {
    setWebsiteInfo: (state, action: PayloadAction<WebsiteInfoState>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setWebsiteInfo } = websiteInfoSlice.actions;
export default websiteInfoSlice.reducer; 